import {
  Box,
  InputBase,
  Slider,
  SliderThumb,
  Typography,
  styled,
} from "@mui/material";
import { useState } from "react";
import { setPrices } from "slices/searchListingReducer";
import { useAppDispatch } from "store/appHooks";

function valuetext(value: number) {
  return `$${value}`;
}

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  height: 3,
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 28,
    width: 28,
    backgroundColor: "#fff",
    boxShadow: "0px 2px 4px 0px #00000040",
    // border: "1px solid currentColor",
  },
  "& .MuiSlider-track": {
    height: 4,
  },
  "& .MuiSlider-rail": {
    height: 2,
  },
}));

const PriceSection = ({
  values = [],
  onChange,
}: {
  values?: any;
  onChange?: any;
}) => {
  const [value, setValue] = useState<number[]>(values);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue as number[]);
    onChange(newValue);
  };

  return (
    <Box sx={{ px: "4%", py: "20px" }}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "34px",
          color: "#323232",
        }}
      >
        Price range per hour
      </Typography>
      <Box sx={{ p: "20px 30px 30px 30px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            pb: "15px",
          }}
        >
          <Typography
            sx={{ color: "#A2A2A2", fontSize: "15px", lineHeight: "18px" }}
          >
            $0
          </Typography>
          <Typography
            sx={{ color: "#A2A2A2", fontSize: "15px", lineHeight: "18px" }}
          >
            $10,000
          </Typography>
        </Box>
        <AirbnbSlider
          getAriaLabel={() => "Temperature range"}
          defaultValue={value}
          onChange={handleChange}
          onBlur={() => onChange(value)}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
          min={0}
          max={10000}
          size="medium"
          key="range-picker"
          disableSwap
          step={10}
          // slots={{
          //   thumb: (props) => {
          //     const { children, ...other } = props;
          //     return <SliderThumb {...other}>{children}</SliderThumb>;
          //   },
          // }}
        />
      </Box>

      <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
        <Box
          sx={{
            border: "1px solid #E2E2E2",
            borderRadius: "10px",
            padding: "10px 20px",
          }}
        >
          <Typography
            sx={{ color: "#A2A2A2", fontSize: "13px", lineHeight: "22px" }}
          >
            Minimum
          </Typography>
          <InputBase
            type="number"
            sx={{
              fontSize: "15px",
              fontWeight: 600,
              lineHeight: "22px",
            }}
            startAdornment={"$ "}
            value={value[0]}
            onChange={({ target }) =>
              handleChange(null, [
                !target.value ? null : Number(target.value),
                value[1],
              ])
            }
          />
        </Box>
        <Typography
          sx={{
            lineHeight: "22px",
            fontSize: "15px",
            color: "#383838",
            transform: "scale(2)",
          }}
        >
          -
        </Typography>
        <Box
          sx={{
            border: "1px solid #E2E2E2",
            borderRadius: "10px",
            padding: "10px 20px",
          }}
        >
          <Typography
            sx={{ color: "#A2A2A2", fontSize: "13px", lineHeight: "22px" }}
          >
            Maximum
          </Typography>
          <InputBase
            type="number"
            sx={{
              fontSize: "15px",
              fontWeight: 600,
              lineHeight: "22px",
            }}
            startAdornment={"$ "}
            value={value[1]}
            onChange={({ target }) => {
              handleChange(null, [
                value[0],
                !target.value ? null : Number(target.value),
              ]);
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PriceSection;
